import React, { Component } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  InputGroup,
  InputGroupText,
  Row,
  Col,
  Alert,
} from "reactstrap";
import Draggable from "react-draggable";
import { FetchData } from "./utils/DataFetch";
import { GetCookie, Timeout } from "./utils/Common";

import { WorkOrderFormSearch } from "./WorkOrderFormSearch";
import { ClientFormSearch } from "./ClientFormSearch";
import { ClaimantFormSearch } from "./ClaimantFormSearch";
import { RepFormSearch } from "./RepFormSearch";
import { InterpreterFormSearch } from "./InterpreterFormSearch";
import { ProviderFormSearch } from "./ProviderFormSearch";

import { TroubleTicketActionForm } from "./TroubleTicketActionForm";
import { TroubleTicketActionTableDefault } from "./TroubleTicketActionTableDefault";
import { ClientForm } from "./ClientForm";
import { ClaimantForm } from "./ClaimantForm";
import { RepForm } from "./RepForm";
import { InterpreterForm } from "./InterpreterForm";
import { ProviderOfficeForm } from "./ProviderOfficeForm";

const moment = require("moment");

export class TroubleTicketForm extends Component {
  static displayName = TroubleTicketForm.name;

  constructor(props) {
    super(props);

    this.user = JSON.parse(GetCookie("user"));
    this.state = {
      model: props.model,
      alert: props.alert,
      deltaPosition: { x: 0, y: 0 },
      modalWorkOrderSearch: false,
      modalClientSearch: false,
      modalClaimantSearch: false,
      modalRepSearch: false,
      modalInterpreterSearch: false,
      modalProviderSearch: false,
      userList: JSON.parse(localStorage.getItem("TimeOffUsers")) || [],
      actionList: [],
      modalActionForm: false,
      actionFormModel: null,
      // Entity detail form states
      modalClientForm: false,
      clientFormModel: null,
      modalClaimantForm: false,
      claimantFormModel: null,
      modalRepForm: false,
      repFormModel: null,
      modalInterpreterForm: false,
      interpreterFormModel: null,
      modalProviderForm: false,
      providerFormModel: null,
    };

    this.onSave = this.onSave.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.keydownHandler = this.keydownHandler.bind(this);
    this.handleSaveEventSuccess = this.handleSaveEventSuccess.bind(this);
    this.setModalWorkOrderSearch = this.setModalWorkOrderSearch.bind(this);
    this.handleWorkOrderSelected = this.handleWorkOrderSelected.bind(this);
    this.setModalClientSearch = this.setModalClientSearch.bind(this);
    this.handleClientSelected = this.handleClientSelected.bind(this);
    this.setModalClaimantSearch = this.setModalClaimantSearch.bind(this);
    this.handleClaimantSelected = this.handleClaimantSelected.bind(this);
    this.setModalRepSearch = this.setModalRepSearch.bind(this);
    this.handleRepSelected = this.handleRepSelected.bind(this);
    this.setModalInterpreterSearch = this.setModalInterpreterSearch.bind(this);
    this.handleInterpreterSelected = this.handleInterpreterSelected.bind(this);
    this.setModalProviderSearch = this.setModalProviderSearch.bind(this);
    this.handleProviderSelected = this.handleProviderSelected.bind(this);
    this.handleActionEdit = this.handleActionEdit.bind(this);
    this.handleActionDelete = this.handleActionDelete.bind(this);
  }

  componentDidMount() {
    document.addEventListener("keydown", this.keydownHandler);
    if (this.state.model.TroubleTicketId) {
      this.populateActions();
    }
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.keydownHandler);
  }

  onStart = () => {};

  onStop = () => {};

  handleDrag = (e, ui) => {
    const { deltaPosition } = this.state;
    this.setState({
      deltaPosition: {
        x: deltaPosition.x + ui.deltaX,
        y: deltaPosition.y + ui.deltaY,
      },
    });
  };

  handleChange(e) {
    let model = { ...this.state.model };
    if (e.target.type === "checkbox") model[e.target.name] = e.target.checked;
    else if (e.target.type === "number") {
      if (e.target.value !== "")
        model[e.target.name] = parseFloat(e.target.value);
      else model[e.target.name] = null;
    } else {
      model[e.target.name] = e.target.value;
    }

    this.setState({ model });
  }

  keydownHandler(e) {
    if (e.keyCode === 83 && e.altKey) {
      if (this.state.modalActionForm || e.defaultPrevented) return;
      e.preventDefault();
      this.onSave();
    }
  }

  handleSaveEventSuccess(alert) {
    this.setState(
      {
        alert: {
          color: alert.color,
          message: alert.message,
          isOpen: true,
        },
      },
      () => {
        window.setTimeout(() => {
          this.setState({ alert: { isOpen: false } });
        }, Timeout(alert.message));
      },
    );
  }

  onSave() {
    let model = { ...this.state.model };

    if (model.EventType === "insert") {
      model.TroubleTicketId = crypto.randomUUID();
      model.CreateByUserId = this.user.userid;
    } else if (model.EventType === "update") {
      model.UpdateByUserId = this.user.userid;
    }

    FetchData("/savetroubleticket", "POST", this.user.token, model).then(
      (data) => {
        this.handleSaveEventSuccess({
          message: data,
          color: data === "Success" ? "success" : "warning",
        });
        if (data === "Success") {
          if (model.EventType === "insert") {
            this.setState({
              model: {
                ...this.state.model,
                TroubleTicketId: model.TroubleTicketId,
                EventType: "update",
              },
            });
          }
          this.props.onSaveSuccess(model);
        }
      },
    );
  }

  onDelete() {
    let model = { ...this.state.model };
    model.EventType = "delete";
    model.IsDeletedFlg = true;
    model.UpdateByUserId = this.user.userid;

    FetchData("/savetroubleticket", "POST", this.user.token, model).then(
      (data) => {
        if (data === "Success") {
          this.props.handleSaveEventSuccess({
            message: data,
            modal: false,
            color: "success",
          });
        } else {
          this.handleSaveEventSuccess({
            message: data,
            modal: true,
            color: "warning",
          });
        }
      },
    );
  }

  populateActions() {
    FetchData("/gettroubleticketactions", "POST", this.user.token, {
      TroubleTicketId: this.state.model.TroubleTicketId,
    }).then((data) => {
      if (Array.isArray(data)) {
        this.setState({ actionList: data });
      }
    });
  }

  resetActionFields() {
    this.setState({
      modalActionForm: true,
      actionFormModel: {
        EventType: "insert",
        TroubleTicketActionId: crypto.randomUUID(),
        TroubleTicketId: this.state.model.TroubleTicketId,
        ActionDateTime: new Date().toISOString(),
        ActionDescription: "",
        NextSteps: "",
        ActionStatus: "Open",
        CreateByUserId: null,
        UpdateByUserId: null,
        IsDeletedFlg: false,
      },
    });
  }

  handleActionDoubleClick(event) {
    const d = event.data;
    this.setState({
      modalActionForm: true,
      actionFormModel: {
        EventType: "update",
        TroubleTicketActionId: d.troubleTicketActionId,
        TroubleTicketId: d.troubleTicketId,
        ActionDateTime: d.actionDateTime,
        ActionDescription: d.actionDescription,
        NextSteps: d.nextSteps,
        ActionStatus: d.actionStatus,
        CreateByUserId: d.createByUserId,
        UpdateByUserId: d.updateByUserId,
        IsDeletedFlg: d.isDeletedFlg,
      },
    });
  }

  handleActionEdit(data) {
    this.setState({
      modalActionForm: true,
      actionFormModel: {
        EventType: "update",
        TroubleTicketActionId: data.troubleTicketActionId,
        TroubleTicketId: data.troubleTicketId,
        ActionDateTime: data.actionDateTime,
        ActionDescription: data.actionDescription,
        NextSteps: data.nextSteps,
        ActionStatus: data.actionStatus,
        CreateByUserId: data.createByUserId,
        UpdateByUserId: data.updateByUserId,
        IsDeletedFlg: data.isDeletedFlg,
      },
    });
  }

  handleActionDelete(data) {
    FetchData("/savetroubleticketaction", "POST", this.user.token, {
      EventType: "delete",
      TroubleTicketActionId: data.troubleTicketActionId,
      UpdateByUserId: this.user.userid,
      IsDeletedFlg: true,
    }).then((result) => {
      this.handleSaveEventSuccess({
        message: result,
        color: result === "Success" ? "success" : "warning",
      });
      if (result === "Success") {
        this.populateActions();
      }
    });
  }

  handleActionSaved(alert) {
    this.setState(
      {
        alert: {
          color: alert.color,
          message: alert.message,
          isOpen: true,
        },
        ...(alert.closeModal && { modalActionForm: false, actionFormModel: null }),
      },
      () => {
        window.setTimeout(() => {
          this.setState({ alert: { isOpen: false } });
        }, Timeout(alert.message));
        this.populateActions();
      },
    );
  }

  // Work Order search
  setModalWorkOrderSearch() {
    this.setState((prevState) => ({
      modalWorkOrderSearch: !prevState.modalWorkOrderSearch,
    }));
  }

  handleWorkOrderSelected(workorder) {
    let model = { ...this.state.model };
    model.JobId = workorder.JobId;
    model.JobNum = workorder.JobNum;
    model.ClientId = workorder.ClientId || null;
    model.ClientName = workorder.ClientName || "";
    model.ClientAbbrv = workorder.ClientAbbrv || "";
    model.ClaimantId = workorder.ClaimantId || null;
    model.ClmFirstName = workorder.ClmFirstName || "";
    model.ClmLastName = workorder.ClmLastName || "";
    model.RepId = workorder.RepId || null;
    model.RepFirstName = workorder.RepFirstName || "";
    model.RepLastName = workorder.RepLastName || "";
    model.IntId = workorder.IntId || null;
    model.IntFirstName = workorder.IntFirstName || "";
    model.IntLastName = workorder.IntLastName || "";
    model.ProvId = workorder.ProvId || null;
    model.ProvOfficeName = workorder.ProviderName || "";
    this.setState({ model, modalWorkOrderSearch: false });
  }

  // Client search
  setModalClientSearch() {
    this.setState((prevState) => ({
      modalClientSearch: !prevState.modalClientSearch,
    }));
  }

  handleClientSelected(event) {
    const client = event.data;
    let model = { ...this.state.model };
    model.ClientId = client.clientId;
    model.ClientName = client.clientName;
    model.ClientAbbrv = client.clientAbbrv;
    this.setState({ model, modalClientSearch: false });
  }

  // Claimant search
  setModalClaimantSearch() {
    this.setState((prevState) => ({
      modalClaimantSearch: !prevState.modalClaimantSearch,
    }));
  }

  handleClaimantSelected(event) {
    const clm = event.data;
    let model = { ...this.state.model };
    model.ClaimantId = clm.clmId;
    model.ClmFirstName = clm.clmFirstName;
    model.ClmLastName = clm.clmLastName;
    this.setState({ model, modalClaimantSearch: false });
  }

  // Rep search
  setModalRepSearch() {
    this.setState((prevState) => ({
      modalRepSearch: !prevState.modalRepSearch,
    }));
  }

  handleRepSelected(event) {
    const rep = event.data;
    let model = { ...this.state.model };
    model.RepId = rep.repId;
    model.RepFirstName = rep.repFirstName;
    model.RepLastName = rep.repLastName;
    this.setState({ model, modalRepSearch: false });
  }

  // Interpreter search
  setModalInterpreterSearch() {
    this.setState((prevState) => ({
      modalInterpreterSearch: !prevState.modalInterpreterSearch,
    }));
  }

  handleInterpreterSelected(event) {
    const interp = event.data;
    let model = { ...this.state.model };
    model.IntId = interp.intId;
    model.IntFirstName = interp.intFirstName;
    model.IntLastName = interp.intLastName;
    this.setState({ model, modalInterpreterSearch: false });
  }

  // Provider search
  setModalProviderSearch() {
    this.setState((prevState) => ({
      modalProviderSearch: !prevState.modalProviderSearch,
    }));
  }

  handleProviderSelected(event) {
    const prov = event.data;
    let model = { ...this.state.model };
    model.ProvId = prov.provId;
    model.ProvOfficeName = prov.provLastName;
    this.setState({ model, modalProviderSearch: false });
  }

  getDisplayName(first, last) {
    if (first && last) return `${last}, ${first}`;
    return last || first || "";
  }

  openClientForm() {
    const m = this.state.model;
    if (!m.ClientId) return;
    FetchData("/getclients", "POST", this.user.token, {
      ClientId: m.ClientId,
      ClientName: "",
      ClientAbbrv: "",
      Org: "",
      Phone: "",
      SortBy: "",
      SortDirection: "",
    }).then((data) => {
      if (Array.isArray(data) && data.length > 0) {
        const d = data[0];
        this.setState({
          modalClientForm: true,
          clientFormModel: {
            EventType: "update",
            ClientId: d.clientId,
            ClientAbbrv: d.clientAbbrv,
            ClientName: d.clientName,
            ClientPhone: d.clientPhone,
            ClientPhone2: d.clientPhone2,
            ClientPhoneFax: d.clientPhoneFax,
            ClientEmail: d.clientEmail,
            ClientEmailForInvoice: d.clientEmailForInvoice,
            ClientStreet: d.clientStreet,
            ClientStreet2: d.clientStreet2,
            ClientCity: d.clientCity,
            ClientState: d.clientState,
            ClientZip: d.clientZip,
            ClientMailStreet: d.clientMailStreet,
            ClientMailStreet2: d.clientMailStreet2,
            ClientMailCity: d.clientMailCity,
            ClientMailState: d.clientMailState,
            ClientMailZip: d.clientMailZip,
            ClientOrg: d.clientOrg,
            ClientCountry: d.clientCountry,
            ClientWebsite: d.clientWebsite,
            ClientDiscount: d.clientDiscount,
            ClientNotes: d.clientNotes,
            ClientInvoiceNote: d.clientInvoiceNote,
            ClientCreditCard: d.clientCreditCard,
            ClientBillRateType: d.clientBillRateType,
            ClientInactiveFlg: d.clientInactiveFlg,
            CreateDateTime: d.createDateTime,
            CreateByUserId: d.createByUserId,
            UpdateByUserId: d.updateByUserId,
            UpdateDateTime: d.updateDateTime,
            IsDeletedFlg: d.isDeletedFlg,
          },
        });
      }
    });
  }

  openClaimantForm() {
    const m = this.state.model;
    if (!m.ClaimantId) return;
    FetchData("/getclaimants", "POST", this.user.token, {
      ClmId: m.ClaimantId,
      Name: "",
      ClmClaimNumberNoDash: "",
      ClientAbbrv: "",
      Phone: "",
      Employer: "",
      Insured: "",
      SortBy: "",
      SortDirection: "",
    }).then((data) => {
      if (Array.isArray(data) && data.length > 0) {
        const d = data[0];
        this.setState({
          modalClaimantForm: true,
          claimantFormModel: {
            EventType: "update",
            ClmId: d.clmId,
            RepId: d.repId,
            ClientId: d.clientId,
            ClmFirstName: d.clmFirstName,
            ClmLastName: d.clmLastName,
            ClmClaimNumber: d.clmClaimNumber,
            ClmClaimNumberNoDash: d.clmClaimNumberNoDash,
            ClmLanguage: d.clmLanguage,
            ClmPhone: d.clmPhone,
            ClmEmail: d.clmEmail,
            ClmStatus: d.clmStatus,
            ClmInvoiceType: d.clmInvoiceType,
            ClmInvoiceCaption: d.clmInvoiceCaption,
            ClmDateOfInjury: d.clmDateOfInjury,
            ClmDateOfInjuryStart: d.clmDateOfInjuryStart,
            ClmDateOfInjuryEnd: d.clmDateOfInjuryEnd,
            ClmDateOfLoss: d.clmDateOfLoss,
            ClmDOB: d.clmDOB,
            ClmEmployer: d.clmEmployer,
            ClmInsuredParty: d.clmInsuredParty,
            ClmHasAttorneyFlg: d.clmHasAttorneyFlg,
            ClmWCABNumber: d.clmWCABNumber,
            ClmNote: d.clmNote,
            ClmStreet: d.clmStreet,
            ClmCity: d.clmCity,
            ClmState: d.clmState,
            ClmZip: d.clmZip,
            ClmSSN: d.clmSSN,
            ClmOrderedByName: d.clmOrderedByName,
            ClmDiagnosis: d.clmDiagnosis,
            ClmGender: d.clmGender,
            ClmAppAtty: d.clmAppAtty,
            ClmAppAttyFirm: d.clmAppAttyFirm,
            ClmAppAttyPhone: d.clmAppAttyPhone,
            ClmAppAttyEmail: d.clmAppAttyEmail,
            ClmDefAtty: d.clmDefAtty,
            ClmDefAttyFirm: d.clmDefAttyFirm,
            ClmDefAttyPhone: d.clmDefAttyPhone,
            ClmDefAttyEmail: d.clmDefAttyEmail,
            ClmHeight: d.clmHeight,
            ClmWeight: d.clmWeight,
            ClientName: d.clientName,
            ClientAbbrv: d.clientAbbrv,
            RepFirstName: d.repFirstName,
            RepLastName: d.repLastName,
            CreateDateTime: d.createDateTime,
            CreateByUserId: d.createbyUserId,
            UpdateByUserId: d.updateByUserId,
            UpdateDateTime: d.updateDateTime,
            IsDeletedFlg: d.isDeletedFlg,
          },
        });
      }
    });
  }

  openRepForm() {
    const m = this.state.model;
    if (!m.RepId) return;
    FetchData("/getreps", "POST", this.user.token, {
      RepId: m.RepId,
      ClientId: null,
      RepName: "",
      Phone: "",
      Email: "",
      SortBy: "",
      SortDirection: "",
    }).then((data) => {
      if (Array.isArray(data) && data.length > 0) {
        const d = data[0];
        this.setState({
          modalRepForm: true,
          repFormModel: {
            EventType: "update",
            RepId: d.repId,
            ClientId: d.clientId,
            RepFirstName: d.repFirstName,
            RepLastName: d.repLastName,
            RepPhone: d.repPhone,
            RepPhone2: d.repPhone2,
            RepZip: d.repZip,
            RepEmail: d.repEmail,
            RepBillingEmail: d.repBillingEmail,
            RepNote: d.repNote,
            RepInactiveFlg: d.repInactiveFlg,
            ClientName: d.clientName,
            ClientAbbrv: d.clientAbbrv,
            ClientPhone: d.clientPhone,
            ClientPhone2: d.clientPhone2,
            ClientEmail: d.clientEmail,
            CreateDateTime: d.createDateTime,
            CreateByUserId: d.createbyUserId,
            UpdateByUserId: d.updateByUserId,
            UpdateDateTime: d.updateDateTime,
            IsDeletedFlg: d.isDeletedFlg,
          },
        });
      }
    });
  }

  openInterpreterForm() {
    const m = this.state.model;
    if (!m.IntId) return;
    FetchData("/getinterpreters", "POST", this.user.token, {
      IntId: m.IntId,
      Name: "",
      Language: "",
      Phone: "",
      Email: "",
      City: "",
      State: "",
      Zip: "",
      ShowAll: false,
      UnVetted: false,
      SortBy: "",
      SortDirection: "",
    }).then((data) => {
      if (Array.isArray(data) && data.length > 0) {
        const d = data[0];
        this.setState({
          modalInterpreterForm: true,
          interpreterFormModel: {
            EventType: "update",
            IntId: d.intId,
            IntFirstName: d.intFirstName,
            IntLastName: d.intLastName,
            IntGender: d.intGender,
            IntPronoun: d.intPronoun,
            IntEmail: d.intEmail,
            IntCellTxt: d.intCellTxt,
            IntPhoneOnly: d.intPhoneOnly,
            IntFax: d.intFax,
            IntBeeper: d.intBeeper,
            IntStreet: d.intStreet,
            IntCity: d.intCity,
            IntState: d.intState,
            IntZip: d.intZip,
            IntCountry: d.intCountry,
            IntSSINumber: d.intSSINumber,
            IntActiveFlg: d.intActiveFlg,
            IntCorporationFlg: d.intCorporationFlg,
            DBA: d.dba,
            InHouseFlg: d.inHouseFlg,
            UnVettedFlg: d.unVettedFlg,
            EmergencyContact: d.emergencyContact,
            UnavailableReason: d.unavailableReason,
            BankName: d.bankName,
            BankAccount: d.bankAccount,
            BankRoute: d.bankRoute,
            Rate: d.rate,
            HourMinimum: d.hourMinimum,
            Prorate: d.prorate,
            ConfCallRate: d.confCallRate,
            BusinessCardRequestDate: d.businessCardRequestDate,
            BusinessCardRequestToProcessFlg: d.businessCardRequestToProcessFlg,
            IntNote: d.intNote,
            ReferredBy: d.referredBy,
            DefaultLanguage: d.defaultLanguage,
            CreateDateTime: d.createDateTime,
            CreateByUserId: d.createByUserId,
            UpdateByUserId: d.updateByUserId,
            UpdateDateTime: d.updateDateTime,
            IsDeletedFlg: d.isDeletedFlg,
          },
        });
      }
    });
  }

  openProviderForm() {
    const m = this.state.model;
    if (!m.ProvId) return;
    FetchData("/getprovideroffices", "POST", this.user.token, {
      ProvId: m.ProvId,
      FullName: "",
      ProvLastName: "",
      ProvFirstName: "",
      ProvPhone: "",
      ProvStreet: "",
    }).then((data) => {
      if (Array.isArray(data) && data.length > 0) {
        const d = data[0];
        this.setState({
          modalProviderForm: true,
          providerFormModel: {
            EventType: "update",
            ProvId: d.provId,
            ProvLastName: d.provLastName,
            ProvFirstName: d.provFirstName,
            ProvTitle: d.provTitle,
            ProvSpeciality: d.provSpeciality,
            ProvReceptionist: d.provReceptionist,
            ProvPhone: d.provPhone,
            ProvPhone2: d.provPhone2,
            ProvEmail: d.provEmail,
            ProvStreet: d.provStreet,
            ProvCity: d.provCity,
            ProvState: d.provState,
            ProvZip: d.provZip,
            ProvNote: d.provNote,
            ProvIntNote: d.provIntNote,
            ProvInactiveFlg: d.provInactiveFlg,
            CreateByUserId: d.createByUserId,
            CreateDateTime: d.createDateTime,
            UpdateByUserId: d.updateByUserId,
            UpdateDateTime: d.updateDateTime,
            IsDeletedFlg: d.isDeletedFlg,
          },
        });
      }
    });
  }

  render() {
    const dragHandlers = { onStart: this.onStart, onStop: this.onStop };
    const { deltaPosition } = this.state;
    const m = this.state.model;

    const clientDisplay = m.ClientAbbrv || m.ClientName || "";
    const claimantDisplay = this.getDisplayName(m.ClmFirstName, m.ClmLastName);
    const repDisplay = this.getDisplayName(m.RepFirstName, m.RepLastName);
    const interpDisplay = this.getDisplayName(m.IntFirstName, m.IntLastName);
    const provDisplay = m.ProvOfficeName || "";
    const showResolutionNotes =
      m.TroubleTicketStatus === "Resolved" ||
      m.TroubleTicketStatus === "Closed";

    return (
      <Draggable handle=".handle" onDrag={this.handleDrag} {...dragHandlers}>
        <div>
          <Modal
            isOpen={this.props.modal}
            toggle={this.props.setModal}
            style={{
              transform: `translate(${deltaPosition.x}px, ${deltaPosition.y}px)`,
              width: "900px",
              maxWidth: "900px",
            }}
            backdrop="static"
          >
            <ModalHeader className="handle">
              {m.EventType === "insert"
                ? "New Trouble Ticket"
                : "Edit Trouble Ticket"}
            </ModalHeader>
            <ModalBody>
              <div>
                <Row>
                  <Col>
                    <Alert
                      color={this.state.alert.color}
                      isOpen={this.state.alert.isOpen}
                      style={{ textAlign: "center" }}
                    >
                      {this.state.alert.message}
                    </Alert>
                  </Col>
                </Row>

                {/* Row 1: Ticket # (edit only) */}
                {m.TroubleTicketNumber && (
                  <Row>
                    <Col className="col-6">
                      <InputGroup size="sm">
                        <InputGroupText style={{ width: "110px" }}>
                          Ticket #:
                        </InputGroupText>
                        <input
                          type="text"
                          className="form-control form-control-text"
                          value={m.TroubleTicketNumber || ""}
                          disabled
                        />
                      </InputGroup>
                    </Col>
                  </Row>
                )}

                {/* Row 2: Status | Priority */}
                <Row>
                  <Col className="col-6">
                    <InputGroup size="sm">
                      <InputGroupText style={{ width: "110px" }}>
                        Status:
                      </InputGroupText>
                      <select
                        name="TroubleTicketStatus"
                        className="form-control form-control-text"
                        value={m.TroubleTicketStatus || ""}
                        onChange={this.handleChange}
                      >
                        <option value=""></option>
                        <option value="Open">Open</option>
                        <option value="In Progress">In Progress</option>
                        <option value="Resolved">Resolved</option>
                        <option value="Closed">Closed</option>
                      </select>
                    </InputGroup>
                  </Col>
                  <Col className="col-6">
                    <InputGroup size="sm">
                      <InputGroupText style={{ width: "110px" }}>
                        Priority:
                      </InputGroupText>
                      <select
                        name="Priority"
                        className="form-control form-control-text"
                        value={m.Priority || ""}
                        onChange={this.handleChange}
                      >
                        <option value=""></option>
                        <option value="Critical">Critical</option>
                        <option value="High">High</option>
                        <option value="Medium">Medium</option>
                        <option value="Low">Low</option>
                      </select>
                    </InputGroup>
                  </Col>
                </Row>

                {/* Row 3: Category | Source */}
                <Row>
                  <Col className="col-6">
                    <InputGroup size="sm">
                      <InputGroupText style={{ width: "110px" }}>
                        Category:
                      </InputGroupText>
                      <select
                        name="Category"
                        className="form-control form-control-text"
                        value={m.Category || ""}
                        onChange={this.handleChange}
                      >
                        <option value=""></option>
                        <option value="Scheduling">Scheduling</option>
                        <option value="Quality">Quality</option>
                        <option value="Billing">Billing</option>
                        <option value="Technical">Technical</option>
                        <option value="Interpreter No-Show">
                          Interpreter No-Show
                        </option>
                        <option value="Late Cancellation">
                          Late Cancellation
                        </option>
                        <option value="Document Issue">Document Issue</option>
                        <option value="Communication">Communication</option>
                        <option value="Other">Other</option>
                      </select>
                    </InputGroup>
                  </Col>
                  <Col className="col-6">
                    <InputGroup size="sm">
                      <InputGroupText style={{ width: "110px" }}>
                        Source:
                      </InputGroupText>
                      <select
                        name="Source"
                        className="form-control form-control-text"
                        value={m.Source || ""}
                        onChange={this.handleChange}
                      >
                        <option value=""></option>
                        <option value="Phone">Phone</option>
                        <option value="Email">Email</option>
                        <option value="Internal">Internal</option>
                        <option value="Web Portal">Web Portal</option>
                      </select>
                    </InputGroup>
                  </Col>
                </Row>

                {/* Row 4: Job Number | Due Date */}
                <Row>
                  <Col className="col-6">
                    <InputGroup size="sm">
                      <InputGroupText style={{ width: "110px" }}>
                        Job Number:
                      </InputGroupText>
                      <input
                        type="text"
                        name="JobNum"
                        className="form-control form-control-text"
                        value={m.JobNum || ""}
                        readOnly
                        onClick={this.setModalWorkOrderSearch}
                        style={{ cursor: "pointer" }}
                        autoComplete="off"
                      />
                    </InputGroup>
                  </Col>
                  <Col className="col-6">
                    <InputGroup size="sm">
                      <InputGroupText style={{ width: "110px" }}>
                        Due Date:
                      </InputGroupText>
                      <input
                        type="date"
                        name="DueDate"
                        max="9999-12-31"
                        className="form-control form-control-text"
                        value={
                          m.DueDate
                            ? moment(m.DueDate).format("YYYY-MM-DD")
                            : ""
                        }
                        onChange={(e) => {
                          let model = { ...this.state.model };
                          model.DueDate = e.target.value || null;
                          this.setState({ model });
                        }}
                      />
                    </InputGroup>
                  </Col>
                </Row>

                {/* Row 5: Client | Claimant */}
                <Row>
                  <Col className="col-6">
                    <InputGroup size="sm">
                      <InputGroupText
                        style={{ width: "110px", cursor: "pointer" }}
                        onClick={this.setModalClientSearch}
                        title="Search clients"
                      >
                        Client:
                      </InputGroupText>
                      {m.ClientId ? (
                        <input
                          type="text"
                          className="form-control form-control-text"
                          value={clientDisplay}
                          readOnly
                          onClick={() => this.openClientForm()}
                          style={{
                            cursor: "pointer",
                            color: "#0d6efd",
                            textDecoration: "underline",
                          }}
                          autoComplete="off"
                        />
                      ) : (
                        <input
                          type="text"
                          className="form-control form-control-text"
                          value={clientDisplay}
                          readOnly
                          onClick={this.setModalClientSearch}
                          style={{ cursor: "pointer" }}
                          autoComplete="off"
                        />
                      )}
                      {m.ClientId && (
                        <Button
                          color="link"
                          size="sm"
                          style={{ padding: "0 4px" }}
                          onClick={() => {
                            let model = { ...this.state.model };
                            model.ClientId = null;
                            model.ClientName = "";
                            model.ClientAbbrv = "";
                            this.setState({ model });
                          }}
                        >
                          x
                        </Button>
                      )}
                    </InputGroup>
                  </Col>
                  <Col className="col-6">
                    <InputGroup size="sm">
                      <InputGroupText
                        style={{ width: "110px", cursor: "pointer" }}
                        onClick={this.setModalClaimantSearch}
                        title="Search claimants"
                      >
                        Claimant:
                      </InputGroupText>
                      {m.ClaimantId ? (
                        <input
                          type="text"
                          className="form-control form-control-text"
                          value={claimantDisplay}
                          readOnly
                          onClick={() => this.openClaimantForm()}
                          style={{
                            cursor: "pointer",
                            color: "#0d6efd",
                            textDecoration: "underline",
                          }}
                          autoComplete="off"
                        />
                      ) : (
                        <input
                          type="text"
                          className="form-control form-control-text"
                          value={claimantDisplay}
                          readOnly
                          onClick={this.setModalClaimantSearch}
                          style={{ cursor: "pointer" }}
                          autoComplete="off"
                        />
                      )}
                      {m.ClaimantId && (
                        <Button
                          color="link"
                          size="sm"
                          style={{ padding: "0 4px" }}
                          onClick={() => {
                            let model = { ...this.state.model };
                            model.ClaimantId = null;
                            model.ClmFirstName = "";
                            model.ClmLastName = "";
                            this.setState({ model });
                          }}
                        >
                          x
                        </Button>
                      )}
                    </InputGroup>
                  </Col>
                </Row>

                {/* Row 6: Rep | Interpreter */}
                <Row>
                  <Col className="col-6">
                    <InputGroup size="sm">
                      <InputGroupText
                        style={{ width: "110px", cursor: "pointer" }}
                        onClick={this.setModalRepSearch}
                        title="Search reps"
                      >
                        Rep:
                      </InputGroupText>
                      {m.RepId ? (
                        <input
                          type="text"
                          className="form-control form-control-text"
                          value={repDisplay}
                          readOnly
                          onClick={() => this.openRepForm()}
                          style={{
                            cursor: "pointer",
                            color: "#0d6efd",
                            textDecoration: "underline",
                          }}
                          autoComplete="off"
                        />
                      ) : (
                        <input
                          type="text"
                          className="form-control form-control-text"
                          value={repDisplay}
                          readOnly
                          onClick={this.setModalRepSearch}
                          style={{ cursor: "pointer" }}
                          autoComplete="off"
                        />
                      )}
                      {m.RepId && (
                        <Button
                          color="link"
                          size="sm"
                          style={{ padding: "0 4px" }}
                          onClick={() => {
                            let model = { ...this.state.model };
                            model.RepId = null;
                            model.RepFirstName = "";
                            model.RepLastName = "";
                            this.setState({ model });
                          }}
                        >
                          x
                        </Button>
                      )}
                    </InputGroup>
                  </Col>
                  <Col className="col-6">
                    <InputGroup size="sm">
                      <InputGroupText
                        style={{ width: "110px", cursor: "pointer" }}
                        onClick={this.setModalInterpreterSearch}
                        title="Search interpreters"
                      >
                        Interpreter:
                      </InputGroupText>
                      {m.IntId ? (
                        <input
                          type="text"
                          className="form-control form-control-text"
                          value={interpDisplay}
                          readOnly
                          onClick={() => this.openInterpreterForm()}
                          style={{
                            cursor: "pointer",
                            color: "#0d6efd",
                            textDecoration: "underline",
                          }}
                          autoComplete="off"
                        />
                      ) : (
                        <input
                          type="text"
                          className="form-control form-control-text"
                          value={interpDisplay}
                          readOnly
                          onClick={this.setModalInterpreterSearch}
                          style={{ cursor: "pointer" }}
                          autoComplete="off"
                        />
                      )}
                      {m.IntId && (
                        <Button
                          color="link"
                          size="sm"
                          style={{ padding: "0 4px" }}
                          onClick={() => {
                            let model = { ...this.state.model };
                            model.IntId = null;
                            model.IntFirstName = "";
                            model.IntLastName = "";
                            this.setState({ model });
                          }}
                        >
                          x
                        </Button>
                      )}
                    </InputGroup>
                  </Col>
                </Row>

                {/* Row 7: Provider | Assigned To */}
                <Row>
                  <Col className="col-6">
                    <InputGroup size="sm">
                      <InputGroupText
                        style={{ width: "110px", cursor: "pointer" }}
                        onClick={this.setModalProviderSearch}
                        title="Search providers"
                      >
                        Provider:
                      </InputGroupText>
                      {m.ProvId ? (
                        <input
                          type="text"
                          className="form-control form-control-text"
                          value={provDisplay}
                          readOnly
                          onClick={() => this.openProviderForm()}
                          style={{
                            cursor: "pointer",
                            color: "#0d6efd",
                            textDecoration: "underline",
                          }}
                          autoComplete="off"
                        />
                      ) : (
                        <input
                          type="text"
                          className="form-control form-control-text"
                          value={provDisplay}
                          readOnly
                          onClick={this.setModalProviderSearch}
                          style={{ cursor: "pointer" }}
                          autoComplete="off"
                        />
                      )}
                      {m.ProvId && (
                        <Button
                          color="link"
                          size="sm"
                          style={{ padding: "0 4px" }}
                          onClick={() => {
                            let model = { ...this.state.model };
                            model.ProvId = null;
                            model.ProvOfficeName = "";
                            this.setState({ model });
                          }}
                        >
                          x
                        </Button>
                      )}
                    </InputGroup>
                  </Col>
                  <Col className="col-6">
                    <InputGroup size="sm">
                      <InputGroupText style={{ width: "110px" }}>
                        Assigned To:
                      </InputGroupText>
                      <select
                        name="AssignedToUserId"
                        className="form-control form-control-text"
                        value={m.AssignedToUserId || ""}
                        onChange={(e) => {
                          let model = { ...this.state.model };
                          model.AssignedToUserId = e.target.value || null;
                          const selectedUser = this.state.userList.find(
                            (u) => u.userId === e.target.value,
                          );
                          model.AssignedToFullName = selectedUser
                            ? selectedUser.timeOffUserFullName
                            : "";
                          this.setState({ model });
                        }}
                      >
                        <option value=""></option>
                        {this.state.userList.map((u) => (
                          <option key={u.userId} value={u.userId}>
                            {u.timeOffUserFullName}
                          </option>
                        ))}
                      </select>
                    </InputGroup>
                  </Col>
                </Row>

                {/* Row 8: Workflow
                <Row>
                  <Col className="col-6">
                    <InputGroup size="sm">
                      <InputGroupText style={{ width: '110px' }}>
                        Workflow:
                      </InputGroupText>
                      <input
                        type="text"
                        name="WorkFlowId"
                        className="form-control form-control-text"
                        value={m.WorkFlowId || ''}
                        maxLength={100}
                        onChange={this.handleChange}
                        autoComplete="off"
                      />
                    </InputGroup>
                  </Col>
                </Row>
 */}
                {/* Row 9: Description */}
                <Row>
                  <Col className="col-12">
                    <InputGroup size="sm">
                      <InputGroupText style={{ width: "110px" }}>
                        Description:
                      </InputGroupText>
                      <textarea
                        name="Description"
                        rows="4"
                        className="form-control form-control-text"
                        value={m.Description || ""}
                        onChange={this.handleChange}
                      />
                    </InputGroup>
                  </Col>
                </Row>

                {/* Row 10: Resolution Notes (shown when Resolved/Closed) */}
                {showResolutionNotes && (
                  <Row>
                    <Col className="col-12">
                      <InputGroup size="sm">
                        <InputGroupText style={{ width: "110px" }}>
                          Resolution:
                        </InputGroupText>
                        <textarea
                          name="ResolutionNotes"
                          rows="3"
                          className="form-control form-control-text"
                          value={m.ResolutionNotes || ""}
                          onChange={this.handleChange}
                        />
                      </InputGroup>
                    </Col>
                  </Row>
                )}

                {/* Actions section */}
                {m.TroubleTicketId && (
                  <div style={{ marginTop: "12px" }}>
                    <hr />
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      <strong style={{ fontSize: "12px" }}>Actions</strong>
                      <Button
                        className="btn-secondary-no-background form-control-text"
                        size="sm"
                        onClick={() => this.resetActionFields()}
                      >
                        New Action
                      </Button>
                    </div>
                    <TroubleTicketActionTableDefault
                      actionList={this.state.actionList}
                      onEdit={(data) => this.handleActionEdit(data)}
                      onDelete={(data) => this.handleActionDelete(data)}
                      onDoubleClick={(event) => this.handleActionDoubleClick(event)}
                    />
                  </div>
                )}
              </div>
            </ModalBody>
            <ModalFooter>
              {m.EventType !== "insert" && (
                <Button color="danger" onClick={this.onDelete} size="sm">
                  Delete
                </Button>
              )}
            </ModalFooter>
          </Modal>

          {/* Search Modals */}
          {this.state.modalWorkOrderSearch && (
            <WorkOrderFormSearch
              modal={this.state.modalWorkOrderSearch}
              setModal={this.setModalWorkOrderSearch}
              handleDoubleClick={this.handleWorkOrderSelected}
              JobNum={m.JobNum}
            />
          )}
          {this.state.modalClientSearch && (
            <ClientFormSearch
              modal={this.state.modalClientSearch}
              setModal={this.setModalClientSearch}
              handleDoubleClick={this.handleClientSelected}
              setFetchingData={() => {}}
            />
          )}
          {this.state.modalClaimantSearch && (
            <ClaimantFormSearch
              modal={this.state.modalClaimantSearch}
              setModal={this.setModalClaimantSearch}
              handleDoubleClick={this.handleClaimantSelected}
              alert={this.state.alert}
              Name=""
              workorder={{}}
            />
          )}
          {this.state.modalRepSearch && (
            <RepFormSearch
              modal={this.state.modalRepSearch}
              setModal={this.setModalRepSearch}
              handleDoubleClick={this.handleRepSelected}
              setFetchingData={() => {}}
              RepName=""
            />
          )}
          {this.state.modalInterpreterSearch && (
            <InterpreterFormSearch
              modal={this.state.modalInterpreterSearch}
              setModal={this.setModalInterpreterSearch}
              handleDoubleClick={this.handleInterpreterSelected}
              setFetchingData={() => {}}
              alert={this.state.alert}
              Name=""
            />
          )}
          {this.state.modalProviderSearch && (
            <ProviderFormSearch
              modal={this.state.modalProviderSearch}
              setModal={this.setModalProviderSearch}
              handleDoubleClick={this.handleProviderSelected}
              setFetchingData={() => {}}
              alert={this.state.alert}
              Name=""
            />
          )}

          {/* Action form */}
          {this.state.modalActionForm && this.state.actionFormModel && (
            <TroubleTicketActionForm
              model={this.state.actionFormModel}
              modal={this.state.modalActionForm}
              alert={{ color: "", message: "", isOpen: false }}
              setModal={() =>
                this.setState({ modalActionForm: false, actionFormModel: null })
              }
              onActionSaved={(alert) => this.handleActionSaved(alert)}
            />
          )}

          {/* Entity detail forms */}
          {this.state.modalClientForm && this.state.clientFormModel && (
            <ClientForm
              model={this.state.clientFormModel}
              modal={this.state.modalClientForm}
              alert={{ color: "", message: "", isOpen: false }}
              setModal={() =>
                this.setState({ modalClientForm: false, clientFormModel: null })
              }
              handleSaveEventSuccess={() =>
                this.setState({ modalClientForm: false, clientFormModel: null })
              }
            />
          )}
          {this.state.modalClaimantForm && this.state.claimantFormModel && (
            <ClaimantForm
              model={this.state.claimantFormModel}
              modal={this.state.modalClaimantForm}
              alert={{ color: "", message: "", isOpen: false }}
              setModal={() =>
                this.setState({
                  modalClaimantForm: false,
                  claimantFormModel: null,
                })
              }
              handleSaveEventSuccess={() =>
                this.setState({
                  modalClaimantForm: false,
                  claimantFormModel: null,
                })
              }
            />
          )}
          {this.state.modalRepForm && this.state.repFormModel && (
            <RepForm
              model={this.state.repFormModel}
              modal={this.state.modalRepForm}
              alert={{ color: "", message: "", isOpen: false }}
              setModal={() =>
                this.setState({ modalRepForm: false, repFormModel: null })
              }
              handleSaveEventSuccess={() =>
                this.setState({ modalRepForm: false, repFormModel: null })
              }
            />
          )}
          {this.state.modalInterpreterForm &&
            this.state.interpreterFormModel && (
              <InterpreterForm
                model={this.state.interpreterFormModel}
                modal={this.state.modalInterpreterForm}
                alert={{ color: "", message: "", isOpen: false }}
                setModal={() =>
                  this.setState({
                    modalInterpreterForm: false,
                    interpreterFormModel: null,
                  })
                }
                handleSaveEventSuccess={() =>
                  this.setState({
                    modalInterpreterForm: false,
                    interpreterFormModel: null,
                  })
                }
              />
            )}
          {this.state.modalProviderForm && this.state.providerFormModel && (
            <ProviderOfficeForm
              model={this.state.providerFormModel}
              modal={this.state.modalProviderForm}
              alert={{ color: "", message: "", isOpen: false }}
              setModal={() =>
                this.setState({
                  modalProviderForm: false,
                  providerFormModel: null,
                })
              }
              handleSaveEventSuccess={() =>
                this.setState({
                  modalProviderForm: false,
                  providerFormModel: null,
                })
              }
            />
          )}
        </div>
      </Draggable>
    );
  }
}
